import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ContractModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.8228 2.82275C6.14497 2.82275 4.78482 4.1829 4.78482 5.86073V18.0126C4.78482 19.6905 6.14497 21.0506 7.82279 21.0506H14.9114C16.5892 21.0506 17.9494 19.6905 17.9494 18.0126V7.88604H19.9747V2.82275H17.9494H8.83545H7.8228Z"
            fill="url(#paint0_linear_123_14392)"
          />
          <path
            d="M8.72404 6.47852C8.13595 6.49428 7.84191 6.69381 7.84191 7.07712C7.84191 7.43942 8.1307 7.69409 8.70829 7.84111L8.71617 7.84899C8.72142 7.84899 8.72667 7.84899 8.73192 7.84899C8.74767 7.85424 8.7608 7.85161 8.7713 7.84111C8.7818 7.82536 8.78705 7.80961 8.78705 7.79385V6.54941C8.78705 6.50215 8.76605 6.47852 8.72404 6.47852ZM8.81068 10.2985C9.37252 10.2617 9.65344 10.0333 9.65344 9.61326C9.65344 9.41898 9.59043 9.25883 9.46441 9.13281C9.33839 9.00679 9.11786 8.89915 8.80281 8.80989C8.7608 8.79939 8.7398 8.81514 8.7398 8.85715V10.2355C8.7398 10.2775 8.76342 10.2985 8.81068 10.2985ZM7.96005 8.53422C7.19343 8.20342 6.81012 7.71772 6.81012 7.07712C6.81012 6.63605 6.97027 6.28687 7.29057 6.02958C7.61612 5.77229 8.09395 5.64102 8.72404 5.63577C8.76605 5.63577 8.78705 5.61214 8.78705 5.56488V5.24196C8.78705 5.13169 8.82381 5.0398 8.89732 4.96629C8.97608 4.88753 9.0706 4.84814 9.18087 4.84814C9.29113 4.84814 9.38302 4.88753 9.45653 4.96629C9.5353 5.0398 9.57468 5.13169 9.57468 5.24196V5.62002C9.57468 5.65677 9.59568 5.6804 9.63769 5.6909C9.78471 5.70665 9.92911 5.73028 10.0709 5.76179C10.2021 5.78804 10.3072 5.85368 10.3859 5.95869C10.4699 6.06371 10.5119 6.18448 10.5119 6.321V6.34463C10.5119 6.4549 10.4673 6.54153 10.3781 6.60454C10.294 6.6623 10.1969 6.67806 10.0866 6.6518C9.93436 6.60979 9.78471 6.57829 9.63769 6.55729C9.59568 6.54679 9.57468 6.56516 9.57468 6.61242V7.99864V8.03802C9.56418 8.08002 9.57993 8.11153 9.62193 8.13253C10.0157 8.30056 10.294 8.50009 10.4568 8.73113C10.6248 8.96216 10.7089 9.25096 10.7089 9.59751C10.7089 10.0753 10.5461 10.4481 10.2205 10.7159C9.90023 10.9785 9.42503 11.1202 8.79493 11.1413C8.75817 11.1413 8.7398 11.1649 8.7398 11.2121V11.5429C8.7398 11.6532 8.70042 11.7451 8.62165 11.8186C8.54814 11.8974 8.45625 11.9368 8.34598 11.9368C8.23572 11.9368 8.1412 11.8974 8.06244 11.8186C7.98893 11.7451 7.95217 11.6532 7.95217 11.5429V11.1728C7.95217 11.1308 7.92592 11.1045 7.87341 11.094C7.72114 11.073 7.55311 11.0362 7.36933 10.9837C7.24331 10.947 7.14092 10.8735 7.06216 10.7632C6.98865 10.6477 6.95189 10.5217 6.95189 10.3851V10.3221C6.95189 10.2224 6.9939 10.1436 7.07791 10.0858C7.16718 10.0281 7.25906 10.0202 7.35358 10.0622C7.53211 10.1357 7.70801 10.1909 7.88129 10.2276C7.89704 10.2329 7.91279 10.2302 7.92854 10.2197C7.9443 10.204 7.95217 10.1882 7.95217 10.1725V8.78626C7.95217 8.718 7.96267 8.66287 7.98368 8.62086C8.00468 8.57885 7.99681 8.54997 7.96005 8.53422Z"
            fill="#002F35"
          />
          <path
            d="M6.81012 13.4558C6.81012 13.1762 7.03681 12.9495 7.31645 12.9495H15.4177C15.6974 12.9495 15.924 13.1762 15.924 13.4558C15.924 13.7354 15.6974 13.9621 15.4177 13.9621H7.31645C7.03681 13.9621 6.81012 13.7354 6.81012 13.4558Z"
            fill="#002F35"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3924 9.91138C13.1128 9.91138 12.8861 10.1381 12.8861 10.4177C12.8861 10.6973 13.1128 10.924 13.3924 10.924H15.4177C15.6974 10.924 15.9241 10.6973 15.9241 10.4177C15.9241 10.1381 15.6974 9.91138 15.4177 9.91138H13.3924ZM13.3924 15.9873C13.1128 15.9873 12.8861 16.214 12.8861 16.4937C12.8861 16.7733 13.1128 17 13.3924 17H15.4177C15.6974 17 15.9241 16.7733 15.9241 16.4937C15.9241 16.214 15.6974 15.9873 15.4177 15.9873H13.3924Z"
            fill="#002F35"
          />
          <path
            d="M12.8861 7.37986C12.8861 7.10023 13.1128 6.87354 13.3924 6.87354H15.4177C15.6974 6.87354 15.9241 7.10023 15.9241 7.37986C15.9241 7.6595 15.6974 7.88619 15.4177 7.88619H13.3924C13.1128 7.88619 12.8861 7.6595 12.8861 7.37986Z"
            fill="#002F35"
          />
          <path
            d="M12.1266 15.9873H2V18.0126C2 19.6904 3.36015 21.0506 5.03798 21.0506H14.1519C14.2411 21.0506 14.3294 21.0468 14.4167 21.0392C13.1318 20.9176 12.1266 19.8357 12.1266 18.5189V15.9873Z"
            fill="url(#paint1_linear_123_14392)"
          />
          <path
            d="M17.9494 4.84807C17.9494 3.72952 18.8561 2.82275 19.9747 2.82275C21.0932 2.82275 22 3.72952 22 4.84807V8.8987H17.9494V4.84807Z"
            fill="url(#paint2_linear_123_14392)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14392"
              x1="11.3671"
              y1="5.3544"
              x2="11.3671"
              y2="17.5063"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#03F480" />
              <stop offset="1" stop-color="#00E1D6" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14392"
              x1="9.33067"
              y1="15.9873"
              x2="9.34177"
              y2="21.0506"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1CCA77" />
              <stop offset="1" stop-color="#01FEF0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_123_14392"
              x1="19.9747"
              y1="8.39237"
              x2="19.9747"
              y2="2.82275"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#01FEF0" />
              <stop offset="1" stop-color="#1BCA78" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ContractModule;
